import { render, staticRenderFns } from "./EcommerceFinancialStatistics.vue?vue&type=template&id=9f5584e2&"
import script from "./EcommerceFinancialStatistics.vue?vue&type=script&lang=js&"
export * from "./EcommerceFinancialStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports